import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { AppConfigEffects } from './app-config/app-config.effects';
import { appConfigReducer } from './app-config/app-config.reducer';
import { ClientsEffects } from './clients/clients.effects';
import { clientsReducer } from './clients/clients.reducer';
import { FilesEffects } from './files/files.effects';
import { filesReducer } from './files/files.reducer';
import { httpErrorReducer } from './http-error/http-error.reducer';
import { InvitationEffects } from './invitation/invitation.effects';
import { invitationReducer } from './invitation/invitation.reducer';
import { InvoiceDocumentEffects } from './invoice-documents/invoice-document.effects';
import { invoiceDocumentReducer } from './invoice-documents/invoice-document.reducer';
import { navigationReducer } from './navigation/navigation.reducers';
import { PdfEffects } from './pdf-generation/generate-pdf.effects';
import { pdfReducer } from './pdf-generation/generate-pdf.reducer';
import { ProjectExpensesEffects } from './projects/expenses/project-expenses.effects';
import { projectExpensesReducer } from './projects/expenses/project-expenses.reducer';
import { ProjectsEffects } from './projects/projects.effects';
import { projectsReducer } from './projects/projects.reducer';
import { StatusEffects } from './projects/status/status.effects';
import { statusReducer } from './projects/status/status.reducer';
import { TasksEffects } from './projects/tasks/tasks.effects';
import { tasksReducer } from './projects/tasks/tasks.reducer';
import { AbsenceReasonsEffects } from './settings/absence-reasons/absence-reasons.effects';
import { absenceReasonsReducer } from './settings/absence-reasons/absence-reasons.reducer';
import { HolidayTemplatesEffects } from './settings/holiday-templates/holiday-templates.effects';
import { holidayTemplatesReducer } from './settings/holiday-templates/holiday-templates.reducer';
import { TagsEffects } from './tags/tags.effects';
import { tagsReducer } from './tags/tags.reducer';
import { TimeBlocksEffects } from './time-blocks/time-block-entries/time-blocks.effects';
import { timeBlocksReducer } from './time-blocks/time-block-entries/time-blocks.reducer';
import { TimerEffects } from './time-blocks/timer/timer.effects';
import { TodoPlannerEntriesEffects } from './todo-planner/todo-planner.effects';
import { todoEntriesReducer } from './todo-planner/todo-planner.reducer';
import { UsersEffects } from './users/users.effects';
import { usersReducer } from './users/users.reducer';

export const effects = [
  ProjectsEffects,
  ProjectExpensesEffects,
  PdfEffects,
  StatusEffects,
  ClientsEffects,
  TasksEffects,
  TimeBlocksEffects,
  UsersEffects,
  AppConfigEffects,
  AbsenceReasonsEffects,
  HolidayTemplatesEffects,
  TimerEffects,
  InvoiceDocumentEffects,
  FilesEffects,
  TodoPlannerEntriesEffects,
  TagsEffects,
  TagsEffects,
  InvitationEffects,
];

export const reducers: ActionReducerMap<unknown> = {
  clients: clientsReducer,
  projects: projectsReducer,
  tasks: tasksReducer,
  status: statusReducer,
  users: usersReducer,
  navigation: navigationReducer,
  timeBlocks: timeBlocksReducer,
  httpError: httpErrorReducer,
  appConfig: appConfigReducer,
  absenceReasons: absenceReasonsReducer,
  holidayTemplates: holidayTemplatesReducer,
  pdf: pdfReducer,
  invoiceDocuments: invoiceDocumentReducer,
  files: filesReducer,
  todoEntries: todoEntriesReducer,
  projectExpenses: projectExpensesReducer,
  tags: tagsReducer,
  invite: invitationReducer,
};

export const metaReducers: MetaReducer[] = [];

export interface AppState {}

export const initialState: AppState = {};
